import { Button, IconButton, TableContainer, Table, TableHead, TableRow, TableBody, Paper, TableCell, Typography, Grid } from "@material-ui/core"
import { makeStyles } from '@material-ui/core/styles'
import { DialogMessage } from "../../../global/DialogMessage"
import { ToastMessage } from "../../../global/ToastMessage"
import FCotizacion from "./FCotizacion"
import { useDispatch, useSelector } from "react-redux"
import { formatDinero } from "../../../utils/formatDinero"
import HighlightOffIcon from '@material-ui/icons/HighlightOff'
import { obtenerPlazosBanoAction, obtenerPlanPagosHibrido, addAdultosAction, addMenoresAction, addInfantesAction, addClavePaqueteAction, addItemsAction, modalDetalleExtraAction, newCotizacionPaqueteAction, addMetodoPagoAction, addFechaSalidaAction, obtenerMensualidadesAction, updateCotizacionPaqueteAction, addPaqueteAction, addBancoAction, addBancoMensualidadAction } from "../../../ducks/cotizadorPaqueteDuck"
import { obtenerClientesCotizadorAction, obtenerClientesCotizadorAllAction, modalViewCotizadorAction } from "../../../ducks/cotizadorDuck"
import { StringItemsType } from "../../../constant/StringItemsType"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { useEffect } from "react"
import VisibilityIcon from "@material-ui/icons/Visibility"
import VPagos from "./VPagos"
import MDetalleExtra from "./MDetalleExtra"
import { FormatoFechaIso } from "../../../utils/FormatFecha"
import { catTipoPago } from "../../../constant/catTipoPago"
import { catCotizador } from "../../../constant/constantes"
export const VCambioPasajerosStyle = makeStyles((theme) => ({
    root: {
        margin: "10px 0",
    },
    content: {
        margin: "20px 0",
    },
    contentButton: {
        margin: "20px 0",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "center"
    },
    table: {
        minWidth: 650,
    },
}))

const validaPrecioTotal = ({ mensualidades, metodoPago, bancoMensualidad, total, listaPlazosBanco }) => {
    let montoTotal = total
    if (metodoPago === String(catTipoPago.HIBRIDO) && bancoMensualidad !== "0") {
        let montoMensualidad = mensualidades.reduce((previous, current) => {
            return previous + current.MontoMensualidad
        }, 0)
        let mensualidadBanco = listaPlazosBanco.find(valor => Number(valor?.IdBancoMensualidad) === Number(bancoMensualidad))
        if (mensualidadBanco) {
            return mensualidadBanco.PrecioFinal + montoMensualidad
        }
        // let mensualidadBanco = listaPlazosBanco.find(valor => Number(valor?.IdBancoMensualidad) === Number(bancoMensualidad))
        // if (mensualidadBanco) {
        //     return mensualidadBanco.PrecioFinal ?? 0
        // }
    }
    if (metodoPago === String(catTipoPago.TARJETA_CREDITO) && bancoMensualidad !== "0") {
        let mensualidadBanco = listaPlazosBanco.find(valor => Number(valor?.IdBancoMensualidad) === Number(bancoMensualidad))
        if (mensualidadBanco) {
            return mensualidadBanco.PrecioFinal ?? 0
        }
    }
    return montoTotal
}

const validarPaquete = ({ listaItems, metodoPago, banco, bancoMensualidad }) => {
    if (!listaItems.some(item => item.type === StringItemsType.SALIDA))
        return false
    if (!listaItems.some(item => item.type === StringItemsType.PLAZA))
        return false
    if (!listaItems.some(item => item.quantity >= 1))
        return false
    if (metodoPago === String(catTipoPago.NOAPLICA))
        return false
    if (metodoPago === String(catTipoPago.HIBRIDO) || metodoPago === String(catTipoPago.TARJETA_CREDITO)) {
        if (banco === "0")
            return false
        if (bancoMensualidad === 'undefined' || bancoMensualidad === "0" )
            return false
    }
    return true
}

const CambioPaquete = () => {
    const classes = VCambioPasajerosStyle()
    const dispatch = useDispatch()
    const { cliente, update, idCotizacion, cotizacion } = useSelector(store => store.cotizador)
    const { mensualidades, metodoPago, listaItems, montoTotal, banco, cantidadMenores, cantidadInfantes, cantidadAdultos, listaPlazosBanco, paquete, clavePaquete, fechaSalida, bancoMensualidad } = useSelector(store => store.cotizadorPaquete)
    const handleDeleteItem = (idItem) => {
        let arraItems = listaItems.filter(item => item.id !== idItem)
        dispatch(addItemsAction({ listaItem: arraItems }))
    }
    useEffect(() => {
        const loadData = () => {
            let arrayItems = []
            let cantidadMenores = 0
            let cantidadInfantes = 0
            let objetoFechaSalida = {}
            let objetoPaquete = {
                Nombre: cotizacion?.NombrePaquete,
                Descripcion: cotizacion?.Descripcion,
                PrecioPublico: cotizacion?.EnvioPaqueteProveedor?.Precio,
                Moneda: { id_moneda: cotizacion?.Moneda?.id_moneda, Clave: cotizacion?.Moneda?.Clave },
                ClavePaquete: cotizacion?.ClavePaquete,
                MonedaPagoProveedor: { id_moneda: cotizacion?.MonedaProveedor?.id_moneda, Clave: cotizacion?.MonedaProveedor?.Clave },
                TipoCambioPrevisto: cotizacion?.TipoCambioPrevisto,
                envioPaqueteProveedor: { IdObjeto: cotizacion?.EnvioPaqueteProveedor?.IdObjeto },
                Internacional: cotizacion?.Internacional
            }
            let itemPaquete = {
                id: `${cotizacion?.EnvioPaqueteProveedor?.IdObjeto}`,
                name: cotizacion.NombrePaquete,
                price: cotizacion?.EnvioPaqueteProveedor?.Precio,
                currency: cotizacion.Moneda?.Clave,
                type: "PAQUETE",
                quantity: cotizacion?.Adultos
            }
            arrayItems.push(itemPaquete)
            let arraySuplementos = cotizacion?.lContizacionSuplemento.map((suplemento, index) => {
                let itemSuplemento = {
                    id: suplemento.IdObjeto,
                    name: suplemento.Descripcion,
                    price: suplemento.Precio,
                    currency: cotizacion.Moneda?.Clave,
                    type: suplemento.TipoSuplemento,
                    quantity: suplemento.Cantidad
                }
                if (suplemento.TipoSuplemento.includes("SALIDA")) {
                    objetoFechaSalida = suplemento
                    itemSuplemento.name = `${FormatoFechaIso({ date: cotizacion.FechaSalida, formato: "yyyy/MM/dd" })}`
                }
                if (suplemento.Descripcion.includes("Menor")) {
                    cantidadMenores = suplemento.Cantidad
                    itemSuplemento.type = "PLAZAM"
                }
                if (suplemento.Descripcion === "Infante") {
                    itemSuplemento.type = "PLAZAI"
                    cantidadInfantes = suplemento.Cantidad
                }
                return itemSuplemento
            })
 
            dispatch(addPaqueteAction({ paquete: objetoPaquete }))
            dispatch(addAdultosAction({ cantidad: cotizacion?.Adultos }))
            dispatch(addMenoresAction({ cantidad: cantidadMenores }))
            dispatch(addInfantesAction({ cantidad: cantidadInfantes }))
            dispatch(addClavePaqueteAction({ clavePaquete: cotizacion.ClavePaquete }))
            let arrayItemsC = arrayItems.concat(arraySuplementos)
            dispatch(addItemsAction({ listaItem: arrayItemsC }))
            const total = arrayItemsC.reduce((a, b) => {
                return a + (b.price * b.quantity)
            }, 0)
            let fecha = `${objetoFechaSalida?.IdObjeto},0,${cotizacion.FechaSalida}`
            dispatch(addFechaSalidaAction({ fechaSalida: fecha, fecha: cotizacion.FechaSalida }))

            //* calcular metodos de pago 
            let montoTotal = total
            let montoFinal = total
            let idBanco = 0
            let pagosBanco = 0
            let metodoPago = 0
            let mensualidadBanco = {IdBancoMensualidad : 0}
            // * Obtener el tipo de pago
            cotizacion?.lFormatoPago.forEach(tipoPago => {
                metodoPago = tipoPago?.CatTipoPago?.IdCatTipoPago
                if (tipoPago?.BancoFormatoPago && tipoPago?.CatTipoPago?.IdCatTipoPago === 2) {
                    idBanco = tipoPago?.BancoFormatoPago?.Banco?.IdBanco
                    pagosBanco = tipoPago?.NumeroPagos

                }
            })
            if (cotizacion?.lFormatoPago.length >= 2) {
                metodoPago = catTipoPago.HIBRIDO
            }
            dispatch(addMetodoPagoAction({ metodoPago: String(metodoPago) }))
            dispatch(addBancoAction({ banco: idBanco ?? 0 }))
            if (pagosBanco > 0) {
                mensualidadBanco = listaPlazosBanco.find(valor => Number(valor?.Mensualidad?.Cantidad) === Number(pagosBanco))
            }
            if (!mensualidadBanco) {
                mensualidadBanco = {IdBancoMensualidad: "0"}
            }
            if (metodoPago === catTipoPago.HIBRIDO) {
                montoTotal = montoTotal * catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO
                montoFinal = montoFinal * catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO
                dispatch(obtenerPlanPagosHibrido({
                    FecSalida: cotizacion.FechaSalida,
                    IdBanco: idBanco,
                    NumPagoCIE: catCotizador.CANTIDAD_PAGOS_ADIFERIR,
                    PorCIE: catCotizador.PORCENTAJE_MENSUALIDAD_HIBRIDO * 100,
                    PorTC: catCotizador.PORCENTAJE_TARJETA_CREDITO_HIBRIDO * 100,
                    PrecioPaquete: montoTotal
                }))
            }

            dispatch(obtenerPlazosBanoAction({ IdBanco: idBanco, PrecioPaquete: montoFinal }))
            dispatch(addBancoMensualidadAction({ bancoMensualidad: String(mensualidadBanco?.IdBancoMensualidad) }))
            dispatch(obtenerMensualidadesAction({ fecha: FormatoFechaIso({ date: cotizacion.FechaSalida, formato: "MMddyyyy" }), monto: montoTotal }))
        }
        if (idCotizacion > 0 && cotizacion?.IdCotizacion)
            loadData()
    }, [dispatch, idCotizacion, cotizacion])

    useEffect(() => {
        let arrayItems = [...listaItems]
        arrayItems = arrayItems.map(item => {
            if (item.type === "PAQUETE") {
                if (Number(cantidadAdultos) === 1)
                    return { ...item, quantity: Number(cantidadMenores) + Number(cantidadAdultos) }
                return { ...item, quantity: Number(cantidadAdultos) }
            }
            if (item.type === "SALIDA" || item.type === "EXTRA")
                return { ...item, quantity: Number(cantidadMenores)  + Number(cantidadAdultos) }
            return item
        })
        dispatch(addItemsAction({ listaItem: arrayItems }))
    }, [dispatch, cantidadInfantes, cantidadMenores, cantidadAdultos])

    const handleOpenDetalleExtra = ({ id }) => {
        dispatch(modalDetalleExtraAction({ open: true, idExtra: id }))
    }

    const handleClickGuardar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de gaurdar esta cotización?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(newCotizacionPaqueteAction()).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response.Message,
                        });
                        return null;
                    }
                    dispatch(modalViewCotizadorAction({ open: false }))
                    dispatch(obtenerClientesCotizadorAction())
                    dispatch(obtenerClientesCotizadorAllAction())
                    dispatch(addItemsAction({ listaItem: [] }))
                    dispatch(addMetodoPagoAction({ metodoPago: "0" }))
                    const autoComplete = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[2];
                    if (autoComplete) {
                        autoComplete.click()
                    }
                    const autoComplete2 = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
                    if (autoComplete2) {
                        autoComplete2.click()
                    }
                    ToastMessage.fire(
                        '¡Se aplico el cambio de paquete!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    const handleClickActulizar = () => {
        DialogMessage.fire({
            title: '¿Estas seguro de gaurdar esta cotización?',
            text: '',
            showCancelButton: true,
            confirmButtonText: "Aplicar",
            cancelButtonText: "Cancelar",
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(onLoadAnction({ message: "" }))
                dispatch(updateCotizacionPaqueteAction()).then(Response => {
                    dispatch(offLoadAction())
                    if (Response.status === 500) {
                        ToastMessage.fire({
                            icon: "error",
                            title: "Ha habido un problema intentar mas tarde",
                        });
                        return null;
                    }
                    if (Response.status === 400) {
                        ToastMessage.fire({
                            icon: "warning",
                            title: Response?.Message,
                        });
                        return null;
                    }
                    dispatch(modalViewCotizadorAction({ open: false }))
                    dispatch(obtenerClientesCotizadorAction())
                    dispatch(obtenerClientesCotizadorAllAction())
                    dispatch(addItemsAction({ listaItem: [] }))
                    dispatch(addMetodoPagoAction({ metodoPago: "0" }))
                    const autoComplete = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[2];
                    if (autoComplete) {
                        autoComplete.click()
                    }
                    const autoComplete2 = document.getElementsByClassName('MuiAutocomplete-clearIndicator')[1];
                    if (autoComplete2) {
                        autoComplete2.click()
                    }
                    ToastMessage.fire(
                        '¡Se aplico el cambio de paquete!',
                        '',
                        'success'
                    )
                })
            }
        })
    }
    return (
        <div className={classes.root}>
            <Grid container>
                {/* <Grid item xs={12}>
                    Clinete target: {cliente.Nombre}
                    <br />
                    Total pasajeros: {cantidadPasajeros}
                    <br />
                    update: {`${update}`}
                    <br />
                    idCotizacion: {idCotizacion}
                </Grid> */}
                <Grid item xs={3}>
                    <FCotizacion />
                </Grid>
                <Grid item xs={9}>
                    <div style={{ position: "sticky" }}>
                        <TableContainer component={Paper}>
                            <Table className={classes.table} aria-label="simple table">
                                <TableHead>
                                    <TableRow>
                                        <TableCell align="center">Item</TableCell>
                                        <TableCell align="center">Monto unitario</TableCell>
                                        <TableCell align="center">Cantidad</TableCell>
                                        <TableCell align="center">Monto</TableCell>
                                        <TableCell align="center">Moneda</TableCell>
                                        <TableCell align="center">Acción</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {
                                        listaItems.map((item, index) => {
                                            return (
                                                <TableRow key={item.id}>
                                                    <TableCell align="center">{`${item.type} - ${item.name}`}</TableCell>
                                                    <TableCell align="center">{formatDinero(item.price)}</TableCell>
                                                    <TableCell align="center">{item.quantity}</TableCell>
                                                    <TableCell align="center">{formatDinero(item.price * item.quantity)}</TableCell>
                                                    <TableCell align="center">{item.currency}</TableCell>
                                                    <TableCell align="center">
                                                        {
                                                            (item.type === "EXTRA") &&
                                                            <IconButton onClick={() => { handleDeleteItem(item.id) }}>
                                                                <HighlightOffIcon />
                                                            </IconButton>
                                                        }
                                                        {
                                                            (item.type === "EXTRA") &&
                                                            <IconButton onClick={() => { handleOpenDetalleExtra({ id: item.id }) }}>
                                                                <VisibilityIcon color="primary" />
                                                            </IconButton>
                                                        }
                                                    </TableCell>
                                                </TableRow>
                                            )
                                        })
                                    }
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <div className={classes.content}>
                            <VPagos />
                            <MDetalleExtra />
                            <Typography variant="h6">
                                {/* Total: {formatDinero(montoTotal)} {paquete?.Moneda?.Clave} */}
                                Total: {formatDinero(validaPrecioTotal({ bancoMensualidad, listaPlazosBanco, metodoPago, total: montoTotal, mensualidades }))} {paquete?.Moneda?.Clave}
                            </Typography>
                        </div>
                        <div className={classes.contentButton}>
                            <Button
                                onClick={(update) ? handleClickActulizar : handleClickGuardar}
                                variant="contained"
                                color="primary"
                                disabled={!validarPaquete({ listaItems, metodoPago, banco, bancoMensualidad })}
                            >
                                {
                                    (update) ? "Actulziar" : "Guardar"
                                }
                            </Button>
                        </div>
                    </div>
                </Grid>
            </Grid>
        </div>
    )
}
export default CambioPaquete